<template>
  <div class="DetailBreadCrumbs">
    <div class="breadcrumbs">
      <div class="breadcrumbs-item">
        <a
          :href="PAGE_PATH.BASE_URL"
          target="_blank"
          class="">
          首页
        </a>
        <span class="split-line">/</span>
      </div>

      <div
        class="breadcrumbs-item" v-if="picCategory && picCategory.id">
        <a
          :href=" PAGE_PATH.BASE_URL + PAGE_PATH.TU_PIAN.LIST + '/0-' + picCategory.id +  '-0-0-0-0-0-default-1-0.html' "
          target="_blank"
        >
          {{ picCategory.name }}
        </a>
        <span class="split-line">/</span>

      </div>

      <!-- 增加随机标签  -->
      <div
        class="breadcrumbs-item" v-if="detail && detail._tempTag">
        <a :href=" PAGE_PATH.BASE_URL + PAGE_PATH.TUPIAN_LIST + '/' + detail._tempTag.pinyin + '.html' " target="_blank"
        >
          {{ detail._tempTag.keyword }}
        </a>
        <span class="split-line">/</span>

      </div>


      <div
        class="breadcrumbs-item breadcrumbs-item-title overflow-one">
        <a :href="PAGE_PATH.BASE_URL + PAGE_PATH.TU_PIAN.DETAIL + '/' + detail.uniq_id + '.html'" target="_blank">
          {{ detail.title }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DetailBreadCrumbs",
  props: {
    picCategory: {
      type: Object,
      default: () => {
      }
    },
    detail: {
      type: Object,
      default: () => {
      }
    },
    PAGE_PATH: {
      type: Object,
      default: () => {
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumbs {
  display: flex;
  align-items: center;
  font-size: 0;
  //margin: 18px 0;

  .icon-a-arrowright {
    font-size: 14px;
    margin: 0 2px;
  }

  a {
    font-size: 12px;
    line-height: 20px;
    color: rgba(0, 16, 19, 0.45);
    @include ElementHover(rgba(66, 72, 102, 0.85), '');
  }

  .split-line {
    font-size: 12px;
    color: #8C9395;
    line-height: 16px;
    margin: 0 6px;
  }

  .breadcrumbs-item {
    font-size: 14px;

    &.breadcrumbs-item-title {
      width: 220px;

      a {
        width: 100%;
      }
    }
  }
}
</style>
